import { StepIds } from '~/components/premarketplace/partner-config';
import { CustomerFormValues } from '~/types/marketplace';

type ParentEventType = 'view' | 'track';
type EventActionType = 'opened' | 'closed' | 'next' | 'back' | 'submitted';

type ParentEventPayload = {
  stepName?: StepIds;
  action?: EventActionType;
  payload?: Record<string, string | string[] | number | boolean | null> | Partial<CustomerFormValues>;
};

export const sendParentEvent = (type: ParentEventType, payload?: ParentEventPayload) => {
  const targetOrigin = document.referrer ? new URL(document.referrer).origin : '*';
  const allowedOrigins = ['https://www.brighte.com.au'];

  // Only send to allowed origins or fallback to '*' for development
  const safeOrigin = allowedOrigins.includes(targetOrigin) ? targetOrigin : '*';

  window.parent.postMessage({ type, payload: JSON.stringify(payload) }, safeOrigin);
};
